var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCheckroom = function SvgIconCheckroom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1E1E1E",
    d: "M3 20a.97.97 0 0 1-.712-.288A.97.97 0 0 1 2 19q0-.25.1-.462a.8.8 0 0 1 .3-.338l8.6-6.45V10q0-.424.3-.713.3-.287.725-.287.625 0 1.05-.45t.425-1.075-.437-1.05A1.47 1.47 0 0 0 12 6q-.625 0-1.062.438A1.45 1.45 0 0 0 10.5 7.5h-2q0-1.45 1.025-2.475A3.37 3.37 0 0 1 12 4q1.45 0 2.475 1.013T15.5 7.475a3.43 3.43 0 0 1-.687 2.1A3.5 3.5 0 0 1 13 10.85v.9l8.6 6.45a.8.8 0 0 1 .3.338q.1.212.1.462 0 .424-.288.712A.97.97 0 0 1 21 20zm3-2h12l-6-4.5z"
  })));
};
export default SvgIconCheckroom;